import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CardSetTransformationService, CoreService, DataService, DialogService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { AppDataService } from 'src/app/services/app-data.service';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { FORM_IDENTIFIERS, POP_UP_CODES, QUESTION_CODES, SAVE_RESULT_STATUS } from 'src/app/constants/app-data.constants';
import { take, finalize } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { SaveDataRequestWithParent } from 'src/app/interfaces/save-data.request.interface';

@Component({
  selector: 'app-vptas-application-subsidy',
  templateUrl: './vptas-application-subsidy.component.html',
  styleUrl: './vptas-application-subsidy.component.scss'
})
export class VptasApplicationSubsidyComponent extends BaseCardSetDetailComponent implements OnInit, OnDestroy {

  protected readonly fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;

  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.vptasSubsidy;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  applicationId: string = '';
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    protected dialogService: DialogService,
    private dataService: DataService,
    private errorService: ErrorService,
    private spinnerService: SpinnerService,

  ) {
    super(router, appDataService, dialogService);
  }
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.applicationId = params.get('id') || '';
      if (!this.applicationId) {
        throw new Error('No application id provided in route');
      };      
      this.id = params.get('subsidyId') || '';
      if (this.id) {  
        this.formServiceEndpoint =  API_ENDPOINT_KEYS.getApplicationSubsidyConfigAndResponse;
      }
    });

    const formIdentifiers: any = [
      FORM_IDENTIFIERS.vptsFormIdentifier,
      this.applicationId, // application Id (or entityId) - links documents to this specific application
    ];

    this.coreService.conditionFunctions = 
    {
      true: () => true,
      //readOnly: () => true,
    };
    this.coreService.fileUploadFormIdentifiers['documents'] = formIdentifiers;
  }

  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
  }

  formLoaded(event: any): void {

  }

  buttonClicked(event: any): void {
  }

  filter(event: any): void {
  }

  modelChanged(event: any): void { }

  save(event: SaveFormEvent) {
        if (!event.isFormValid) {
          this.baseForm.markAllFieldsAsTouched();
          this.baseForm.showValidationSummary(true);
          this.dialogService.showPopup(POP_UP_CODES.common.validationError);
          return;
        }
    
        const saveDataRequest: SaveDataRequestWithParent = {
          template: this.templateId,
          versionNumber: this.versionNo,
          id: this.id,
          response: event.model,
          expectedLastUpdateTime: event.lastUpdatedTime ?? '',
          isSubmit: true,
          parentId: this.applicationId
        }
        this.saveData(saveDataRequest);
   }

  cancel(event: any) {
    this.exit();
   }

  private saveData(request: SaveDataRequestWithParent) {
    this.spinnerService.showSpinner();
    this.dataService.saveData(API_ENDPOINTS.vptasApplicationDetails.saveSubsidy, request)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      )
      .subscribe(data => {
        if (data?.status === SAVE_RESULT_STATUS.success) {
          this.router.navigate(['/', ROUTE_CONSTANTS.vptasApplication.prefix, this.applicationId, 'subsidies']);
        }
      });
  }

  private exit(ignoreUnsavedChanges = false): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.vptasApplication.prefix, this.applicationId, 'subsidies']);
  }
}
